import axios from 'axios';
import moment from 'moment';
import UrlEndPoints from './urlEndPoints.json';
import {
  KEY_ACCESS_TOKEN,
  KEY_CONFIG_URL,
  KEY_DATE_FORMAT,
  KEY_LOGIN_ACCESS_TOKEN,
  KEY_AZURE_WEBSITE_URL,
} from '../Helpers/constant';
// import { ApiConfig } from '../Containers/Events/utils/interfaces';
import { RRuleSet, rrulestr } from 'rrule';
import dayjs from 'dayjs';



import { method } from 'lodash';
import { baseURL } from 'tinymce';

let appConfig: any;
export let axiosInstance: any;
const configUrl = KEY_CONFIG_URL;
let paymentInstance: any;
let integrationInstance: any;

const getInsConfig = (config: any) => {
  return config;
};

export const getAxiosInstance = async (data: any) => {
  appConfig = data[0]?.config;
  // appConfig.apiBaseUrl = "https://api-v2.ken42.com/ltpct-stage/pfs-portal"
  appConfig.apiBaseUrl = "`https://learngen-api.turboverse.co"
  appConfig.bbbmiddleware = "https://ltpct-stage-api.ken42.com/pfs-integration/api"
  localStorage.setItem('fileToken', appConfig.lmsToken);
  if (axiosInstance) {
    return axiosInstance;
  }
  axiosInstance = axios.create({
    baseURL: `https://learngen-api.turboverse.co`,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req: any) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers['access-token'] = localStorage.getItem(KEY_LOGIN_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp: any) => {
      return resp;
    },
    async function (error: any) {
      // console.log('ApiService: Interceptor: ', error);
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }
      var config = {
        method: 'get',
        // baseURL: `${appConfig.apiBaseUrl}/token?grant_type=client_credentials`,
        // headers: {
        //   Authorization: `Basic ${appConfig.tokenHeader}`,
        // },
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token
          }`;
        return axios(error.response.config);
      });
    }
  );
};

export const getIntegrationInstance = async () => {
  if (integrationInstance) {
    return integrationInstance;
  }
  integrationInstance = axios.create({
    baseURL: `${appConfig.bbbmiddleware}`,
    timeout: 15000,
  });

  integrationInstance.interceptors.request.use((req: any) => {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    req.headers['access-token'] = localStorage.getItem(KEY_LOGIN_ACCESS_TOKEN);
    return req;
  });

  //Response interceptor for API calls
  integrationInstance.interceptors.response.use(
    (resp: any) => {
      return resp;
    },
    async function (error: any) {
      var config = {
        method: 'get',
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token
          }`;
        return axios(error.response.config);
      });
    }
  );
  return integrationInstance;
};

export const createQuiz = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.createQuiz}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

//Publish/Unpublish quiz, assignments, resources etc.
export const publishUnpublishLMSModule = async (data: any) => {
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.publishUnpublishLMSModule}`,
    {
      method: "post",
      quizid: data.id,
      publish: data.publish
    },
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getPaymentInstance = async (data: any) => {
  appConfig = await getInsConfig(data[0].config);
  paymentInstance = await axios.create({
    baseURL: `${appConfig.paymentBaseUrl}`,
    timeout: 15000,
  });
};

// Request interceptor for API calls

// const ApiService = (method: 'get' | 'post' | 'patch' | 'put' | 'delete', url: string, config: ApiConfig | null = null) => {
//   switch (method) {
//     case 'get':
//       return axiosInstance.get(url);

//     case 'post':
//       return axiosInstance.post(url, config?.body || {});

//     case 'patch':
//       return axiosInstance.patch(url, config?.body || {});

//     case 'put':
//       return axiosInstance.put(url, config?.body || null);

//     case 'delete':
//       return axiosInstance.delete(url);

//     default:
//       console.log('axios default: ', method, url, config);
//       break;
//   }
// };

// export const PaymentApiService = (
//   method: 'get' | 'post' | 'put' | 'delete',
//   url: string,
//   config: ApiConfig | null = null
// ) => {
//   switch (method) {
//     case 'get':
//       return paymentInstance.get(url);

//     case 'post':
//       return paymentInstance.post(url, config?.body || {});

//     case 'put':
//       return paymentInstance.put(url, config?.body || null);

//     case 'delete':
//       return paymentInstance.delete(url);

//     default:
//       console.log('axios default: ', method, url, config);
//       break;
//   }
// };

export const getWhoAmI = async (contactId: any) => {
  const res = await axiosInstance.get(
    `/${UrlEndPoints.WhoAmI}?emailId=${contactId}`
  );
  return res && res.data ? res.data : null;
};

export const authenticate = async (email: any) => {
  const res = await axiosInstance.get(
    `/${UrlEndPoints.authenticate}?UniqueId=${email}`
  );
  return res && res.data ? res.data : null;
};

export const getStudentDetails = async (contactId: any) => {
  const res = await axiosInstance.get(`/${UrlEndPoints.contact}/${contactId}`);
  return res && res.data ? res.data : null;
};

export const getStudentInfo = async (contactId: any) => {
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware
    }/sf/data?api=services/apexrest/ContactDetail/${contactId}`
  );
  // console.log('res-----------------------', res);
  // https://api-v2.ken42.com/sp-jain/stage/pfs/sf/data?api=services/apexrest/ContactDetail/0031y00000KwGxrAAF
  // https://api-v2.ken42.com/sp-jain/stage/pfs/sf/data?api=services/apexrest/ContactDetail/0031y00000KwGxrAAF
  return res && res.data ? res.data : null;
};

export const getAttendanceInfo = async (
  contactId: any,
  startDate = '',
  endDate = ''
) => {
  const query = encodeURIComponent(
    `services/apexrest/StudentAttendanceData?contactId=${contactId}&StartDate=${startDate}&EndDate=${endDate}`
  );
  const res = await axiosInstance.get(
    `${appConfig.bbbmiddleware}/sf/data?api=${query}`
  );
  return res && res.data ? res.data : null;
};



export const getProfileImageData = async (courseOfferingId: any) => {
  const path = `${appConfig.bbbmiddleware}/sf/data?api=`;
  const query = encodeURIComponent(
    `services/apexrest/ContactAttachment/?recordId=${courseOfferingId}&fileName=passportPhoto`
  );
  const res = await axiosInstance.get(`${path}${query}`);
  return res && res.data ? res.data : null;
};


export const facultyActivities = async (
  contactID: any,
  connectionID: any,
  startDate: any,
  endDate: any
) => {
  startDate = moment()
    .subtract(6, 'month')
    .format(KEY_DATE_FORMAT)
    .toLowerCase();
  endDate = moment()
    .add(6, 'months')
    .format(KEY_DATE_FORMAT)
    .toLowerCase();
  const data = {
    useridnumber: contactID,
    connectionid: connectionID,
    modtype: '',
    startdate: startDate,
    enddate: endDate,
    generalsection: '',
    method: 'POST',
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.activities}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};
export const StudentActivities = async (
  contactID: any,
  connectionID: any,
  generalId: any,
  startDate: any,
  endDate: any
) => {
  startDate = moment()
    .subtract(6, 'month')
    .format(KEY_DATE_FORMAT)
    .toLowerCase();
  endDate = moment()
    .add(6, 'months')
    .format(KEY_DATE_FORMAT)
    .toLowerCase();
  const data = {
    useridnumber: contactID,
    connectionid: '',
    modtype: '',
    generalsection: generalId ? '1' : '',
    startdate: startDate,
    enddate: endDate,
  };
  const instance = await getIntegrationInstance();
  const res = await instance.post(
    `/lms?endpoint=${UrlEndPoints.studentactivities}`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return res && res.data ? res.data : null;
};

export const getConfig = async () => {
  // const path = `${window.location.host}`;
  const path = 'ltpct-portal.ken42.com';
  // const path = 'ltpct-stg-portal.ken42.com';
  const res = await axios.get(`${configUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const putAccountDetails = async (studentId: any, data: any) => {
  const path = `${UrlEndPoints.accountDetails}`;
  const res = await axios.put(
    `${appConfig.paymentBaseUrl}/${path}/${studentId}`,
    data
  );
  return res && res.data ? res.data : null;
};

export const getAccountDetails = async (studentId: any) => {
  const path = `${UrlEndPoints.accountDetails}`;
  const res = await axios.get(
    `${appConfig.paymentBaseUrl}/${path}/${studentId}?orgId=${appConfig.orgID}`
  );
  return res && res.data ? res.data : null;
};





 
export const getVerifyUsername = async (username: any, password: any) => {
  const path = `salesforce?endpoint=/services/apexrest/VerifyUsername?username=${username}`;
  const res = await axiosInstance.get(`${appConfig.bbbmiddleware}/${path}`);
  return res && res.data ? res.data : null;
};
export const postChangePassword = async (data: any) => {
  // const path = `salesforce?endpoint=/services/apexrest/ChangePassword`;
  // const res = await axiosInstance.post(
  //   `${appConfig.bbbmiddleware}/${path}`,
  //   data
  // );
  const path = `${appConfig.bbbmiddleware}/salesforce?endpoint=`;
  const query = encodeURIComponent(`services/apexrest/ChangePassword`);
  const res = await axiosInstance.post(`${path}${query}`, data);
  return res && res.data ? res.data : null;
};







export const getTrainingSession = async () => {
  try {
    const path = `https://learngen-api.turboverse.co/generate-training-session`;
    
    const res: any = await axios.get(`${path}`);
    console.log(res, "RESdsfdsds")
    return res && res.data ? res.data : res;
  } catch(error) {
    return error;
  }
}
export const getsession = async () => {
  try {
    const path = `https://learngen-api.turboverse.co/get_session_v1`;
    
    const res: any = await axios.get(`${path}`);
    console.log(res, "data")
    return res && res.data ? res.data : res;
  } catch(error) {
    return error;
  }
}